/* Mobile nav UX fix.
   Default behaviour: tapping a parent menu item's label (e.g. "Shop") navigates
   to its href, which closes the drawer. The accordion only opens if the user
   taps the small chevron exactly. That's poor on touch.
   This script intercepts taps on .mobile-nav__link inside .mobile-nav__has-sublist
   and toggles the accordion instead, matching the chevron's behaviour. */

(function () {
  function enhance() {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || drawer.dataset.mobileNavEnhanced === 'true') return;
    drawer.dataset.mobileNavEnhanced = 'true';

    drawer.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('.mobile-nav__has-sublist > .mobile-nav__link');
        if (!link || !drawer.contains(link)) return;

        // This menu item has children — toggle the accordion, don't navigate.
        event.preventDefault();
        event.stopImmediatePropagation();
        link.parentElement.classList.toggle('mobile-nav--expanded');
      },
      true // capture phase: run before theme.js's bubble-phase listener
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
})();
